export default "__VITE_ASSET__CT1rZ7KN__"